
import global from '@/assets/js/global'
const data = {}
data.rmyjzjUrl = 'http://49.119.100.197:90/'
data.footerData = {
  partyOrgan: 'https://bszs.conac.cn/sitename?method=show&id=4713EBB206AC5539E06310291AAC809A',
  organizer: '中共新疆维吾尔自治区委员会社会工作部',//主办单位
  address: '乌鲁木齐市东风路288号',//地址
  zipCode: '830002',//邮编
  technicalSupport: '中国移动通信集团新疆有限公司',//技术支持
  icpText: '新ICP备2025027564号',//ICP备案号
  icpHttp: 'https://beian.miit.gov.cn/#/Integrated/index',
  publicSecurityHttp: 'https://beian.mps.gov.cn/#/query/webSearch?code=65010202001339',
  publicSecurityText: '新公网安备65010202001339号',
}
data.rdywList = [
  {
    label: '高层声音',
    value: '1',
    navCode: 'gcsy'
  }, {
    label: '疆内要闻',
    value: '2',
    navCode: 'jnyw'
  }, {
    label: '社会工作要闻',
    value: '3',
    navCode: '078'
  }]
// 默认选中
data.ywValue = data.rdywList[0]
data.xxydData = {
  l1: [
    {
      img: 'xxydline1_2.png',
      url: 'http://jhsjk.people.cn/',
    }, {
      img: 'xxydline1_3.png',
      url: 'https://www.dswxyjy.org.cn/GB/427277/422505/422512/index.html',
    }, {
      img: 'xxydline1_4.png',
      url: 'https://www.qstheory.cn/',
    }, {
      img: 'xxydline1_5.png',
      url: 'http://www.dangjian.com/xxhywx/list2_50788_1.html',
    }],
  l2: [
    {
      img: 'xxydline2_3.png',
      url: 'https://djyj.12371.cn/',
    },
    {
      img: 'ddshgzxcjx.png',
      url: '/shgzycjxList?navCode=ddshgzycjx&navName=党的社会工作远程教学',
    },
    {
      img: 'xxydline2_4.png',
      url: 'http://dangjian.people.com.cn/GB/136058/448887/index.html',
    }, {
      img: 'xxydline2_5.png',
      url: 'https://www.12371.cn/special/kjzy/',
    }],
  l3: [
    { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/xxxtA1.png' },
    { label: '', url: 'http://xj.chinavolunteer.mca.gov.cn/subsite/xinjiang/login/2', img: '/xxxtA4.png' },
    { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/xxxtA3.png' },
    { label: '', url: '', img: '/xxxtXJ.png' },
  ],
},
  data.banner2List = [
    { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/banner2_1.png' },
    { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/banner2_2.png' },
  ],
  data.xxxtList = [
    { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/xxxtA1.png' },
    { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/xxxtA2.png' },
    { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/xxxtA3.png' },
  ]
data.rmyjzjList = [
  { label: '新疆维吾尔自治区', url: 'http://49.119.100.197:90/', img: '' },
  { label: '乌鲁木齐市', url: '', img: '' },
  { label: '克拉玛依市', url: 'https://www.klmy.gov.cn/klmys/zjdcwj/yjzj_list.shtml', img: '' },
  { label: '吐鲁番市', url: 'https://www.tlf.gov.cn/tlfs/c106419/hd_myzj.shtml', img: '' },
  { label: '哈密市', url: 'https://www.hami.gov.cn/hami/c120132/hd_zj.shtml', img: '' },
  { label: '阿克苏地区', url: '', img: '' },
  { label: '喀什地区', url: 'http://www.xjks.gov.cn/kss/c107485/yjzj_list.shtml', img: '' },
  { label: '和田地区', url: 'https://hts.gov.cn/poll/', img: '' },
  { label: '昌吉回族自治州', url: '', img: '' },
  { label: '博尔塔拉蒙古自治州', url: '', img: '' },
  { label: '巴音郭楞蒙古自治州', url: 'https://www.xjbz.gov.cn/xjbz/myzj/common_list.shtml', img: '' },
  { label: '克孜勒苏柯尔克孜自治州', url: '', img: '' },
  { label: '伊犁哈萨克自治州', url: '', img: '' },
  { label: '塔城地区', url: 'https://www.xjtcsh.gov.cn/zmhd/myzj/content_53181', img: '' },
  { label: '阿勒泰地区', url: 'http://wap.xjalt.gov.cn/003/003003/list.html', img: '' }
]

data.wxjzList = [
  {
    label: '新疆维吾尔自治区',
    url: 'http://49.119.100.197:90/',
    img: 'xjwwezzq.png',
    wximg: 'xjwwezzq_wx.png',
    value: '01'
  },
  {
    label: '乌鲁木齐市',
    url: '',
    img: 'wlmqs.png',
    wximg: 'wlmqs_wx.png',
    value: '01'
  },
  {
    label: '伊犁哈萨克自治州',
    url: 'https://www.xjyl.gov.cn/xjylz/yjzj/hd_zj.shtml',
    img: 'ylhskzzz.png',
    wximg: 'ylhskzzz_wx.png',
    value: '01'
  },
  {
    label: '塔城地区',
    url: 'https://www.xjtcsh.gov.cn/zmhd/myzj/content_53181',
    img: 'tcdq.png',
    wximg: 'tcdq_wx.png',
    value: '01'
  },

  {
    label: '阿勒泰地区',
    url: 'http://wap.xjalt.gov.cn/003/003003/list.html',
    img: 'altdq.png',
    wximg: 'altdq_wx.png',
    value: '01'
  },
  {
    label: '克拉玛依市',
    url: 'https://www.klmy.gov.cn/klmys/zjdcwj/yjzj_list.shtml',
    img: 'klmys.png',
    wximg: 'klmys_wx.png',
    value: '01'
  },
  {
    label: '博尔塔拉蒙古自治州',
    url: 'https://www.xjboz.gov.cn/info/2164/149774.htm',
    img: 'betlmgzzz.png',
    wximg: 'betlmgzzz_wx.png',
    value: '01'
  },
  {
    label: '昌吉回族自治州',
    url: 'https://cjepsp.cn/news/tzgg/1008263762105552896.html',
    img: 'cjhzzzz.png',
    wximg: 'cjhzzzz_wx.png',
    value: '01'
  },
  {
    label: '哈密市',
    url: 'https://www.hami.gov.cn/hami/c120132/hd_zj.shtml',
    img: 'hms.png',
    wximg: 'hms_wx.png',
    value: '01'
  },
  {
    label: '吐鲁番市',
    url: 'https://www.tlf.gov.cn/tlfs/c106419/hd_myzj.shtml',
    img: 'tlfs.png',
    wximg: 'tlfs_wx.png',
    value: '01'
  },
  {
    label: '巴音郭楞蒙古自治州',
    url: 'https://www.xjbz.gov.cn/xjbz/myzj/common_list.shtml',
    img: 'wjnkyglmgzzz.png',
    wximg: 'wjnkyglmgzzz_wx.png',
    value: '01'
  },
  {
    label: '阿克苏地区',
    url: 'https://www.aks.gov.cn/zmhd/dczj/index.html',
    img: 'aksdq.png',
    wximg: 'aksdq_wx.png',
    value: '01'
  },
  {
    label: '克孜勒苏柯尔克孜自治州',
    url: 'https://www.xjkz.gov.cn/xjkz/c102455/hd_myzj.shtml',
    img: 'kzlskekzzz.png',
    wximg: 'kzlskekzzz_wx.png',
    value: '01'
  },
  {
    label: '喀什地区',
    url: 'http://www.xjks.gov.cn/kss/c107485/yjzj_list.shtml',
    img: 'ksdq.png',
    wximg: 'ksdq_wx.png',
    value: '01'
  },
  {
    label: '和田地区',
    url: 'https://hts.gov.cn/poll/',
    img: 'htdq.png',
    wximg: 'htdq_wx.png',
    value: '01'
  },






]
export default {
  data
}
